import React, {Suspense, lazy, useRef} from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import './App.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/bootstrap4-light-blue/theme.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import SuspenseFallback from './suspenseFallback';
import { Toast } from 'primereact/toast';
import axios from 'axios';
import NewLogin from './containers/login/newLogin';
import EncryptLogin from './containers/login/EncryptLogin';

//const Login = lazy(() => import('./containers/login/login'));
const ProductInfo = lazy(() => import( './containers/productInfo/productInfo'));

function App(props) {
  const toast = useRef(null);
  axios.interceptors.request.use(function (config) {
    if(!config.url.includes('auth/login')) {
      config.headers['Authorization'] = `Barear ${localStorage.getItem("token_JWT")}`;
    }
    // console.log("axios Interseptor : ", config);
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });
  return (
    <div className="App">
      <Toast ref={toast} />
      <Suspense fallback={<SuspenseFallback />}>
        <BrowserRouter>
          <Switch>
            {/* <Route exact path="/">
              <Login toast={toast}></Login>
            </Route> */}

            <Route exact path="/">
              <NewLogin toast={toast}></NewLogin>
            </Route>
            <Route exact path="/productInfo">
              <ProductInfo toast={toast}></ProductInfo>
            </Route>
            <Route exact path="/EncryptLogin">
              <EncryptLogin toast={toast}></EncryptLogin>
            </Route>
          </Switch>
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default App;
